import { SMSDiv, TitleDiv } from "../StyledComponents";

type Props = {
  clientFirstName: string;
};

function Welcome({ clientFirstName }: Props) {
  return (
    <>
      <TitleDiv>
        Bonjour Monsieur/Mme
        {clientFirstName}
      </TitleDiv>
      <br />
      <SMSDiv>Voici votre récapitulatif de livraison</SMSDiv>
    </>
  );
}

export default Welcome;
